import { render, staticRenderFns } from "./SuvIcon.vue?vue&type=template&id=7beb1777&"
import script from "./SuvIcon.vue?vue&type=script&lang=js&"
export * from "./SuvIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports